// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './payments.es-AR.json';
import esMX from './payments.es-MX.json';
import ptBR from './payments.pt-BR.json';

const paymentsTranslations: DomainTranslations = {
  name: 'payments',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default paymentsTranslations;
